const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
export const API_BASE = API_URL + '/api';
